<template>
  <div class="borcliste vezne" :style="'height:'+Height+'px' ">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      v-if="!SeciliBina"
      :closable="false"
      title="Cari listesi için Bina seçiniz"
      type="error">
    </el-alert>
    <el-input
      v-if="SeciliBina && Liste"
      placeholder="Arama"
      prefix-icon="el-icon-search"
      v-model="search">
    </el-input>
    <ul v-if="SeciliBina && Liste"  :style="'height:'+(Height-75)+'px' ">
      <router-link
        v-for="Cari in Liste.filter(data => !search || data.Unvan.toLowerCase().includes(search.toLowerCase()))"
        :to="'/vezne/odeme/'+Cari.Cari_id+'/'+Cari.Bina_id" tag="li" active-class="Aktif">
        <div>
          <div class="kisiBilgi">
            <span class="binaAd">{{Cari.Adi}}</span>
            <span class="borcAd">{{Cari.Unvan}}</span>
          </div>
          <div class="borcBilgi">
            <div class="text-primary text-left" style="width: 100%"><b>Toplam Bakiye</b> {{Cari.BakiyeText}}</div>
            <!--div class="text-success" style="width: 49%"><b>Güncel Bakiye</b> {{Cari.GuncelText}}</div-->
          </div>
        </div>
      </router-link>
      <el-alert
        :closable="false"
        v-if="!Liste.filter(data => !search || data.Unvan.toLowerCase().includes(search.toLowerCase()))[0]"
        title="Uygun Kayıt Bulunamadı"
        type="error">
      </el-alert>
    </ul>
  </div>
</template>
<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ["Yenile"],
    data() {
      return {
        Height: window.innerHeight - 145,
        Cari_id: null,
        SayfaAdi: 'Cari Listesi',
        SeciliBina: null,
        Liste: null,
        search: '',
        lo: false
      }
    },
    methods: {
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'vezne/cariler/' + this.SeciliBina})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
              this.lo = false;
            }
          });
      }
    },
    created() {
      if (this.$store.getters.BinaBilgi) {
        this.SeciliBina = this.$store.getters.BinaBilgi.id;
      }
      this.SayfaYukle();
    },
    computed: {
      rSAyfaYukle() {
        //return this.Yenile
      },
    },
    watch: {
      rSAyfaYukle() {
        //if (this.Yenile) this.SayfaYukle();
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/CariListe.vue